(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetaDialogController', ZetaDialogController);

    ZetaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Zeta', 'Ticket', 'Venta'];

    function ZetaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Zeta, Ticket, Venta) {
        var vm = this;

        vm.zeta = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.tickets = Ticket.query();
        vm.ventas = Venta.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.zeta.id !== null) {
                Zeta.update(vm.zeta, onSaveSuccess, onSaveError);
            } else {
                Zeta.save(vm.zeta, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:zetaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechadesde = false;
        vm.datePickerOpenStatus.fechahasta = false;
        vm.datePickerOpenStatus.fechaoperativa = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
